import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_COMPATIBILITY_VERSION } from '@rivethealth/data/version';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorService } from './ErrorService';

@Injectable({ providedIn: 'root' })
export class ErrorInterceptor implements HttpInterceptor {
  constructor(public errorService: ErrorService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          this.handleAPICompatibility(event);
        }
      }),
      catchError(error => {
        this.handleAPICompatibility(error);
        return throwError(error);
      }),
    );
  }

  handleAPICompatibility(r: HttpResponse<unknown>) {
    // Regardless of status of the request, prompt the
    // user to update if the API_COMPATIBILITY_VERSION
    // is out of date.
    const apiVersion = r.headers.get('X-Rivet-Compatibility-Version');
    if (apiVersion != null && Number(apiVersion) > API_COMPATIBILITY_VERSION) {
      this.errorService.showUpdatePrompt.next(undefined);
    }
  }
}
